import { render, staticRenderFns } from "./Loa.vue?vue&type=template&id=3260f190&"
import script from "./Loa.vue?vue&type=script&lang=js&"
export * from "./Loa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports